<div class="max-w-2xl mx-auto p-6">
  <form [formGroup]="identificationForm" class="space-y-6">
    <!-- Name Field -->

    <app-shared-input
      [icon]="'ph ph-user'"
      [inputId]="'name'"
      [label]="
        identificationForm.get('userType')?.value === 'organization' ? 'PAYMENT_REPORT.organizationName' : 'Name'
      "
      [control]="identificationForm.get('name')!"
      [placeholder]="
        identificationForm.get('userType')?.value === 'organization' ? 'Enter organization name' : 'Enter your name'
      "
      [errorMessage]="'VALIDATION.nameRequired' | translate"
    ></app-shared-input>

    <!-- Email Field -->

    <app-shared-input
      [icon]="'ph ph-envelope'"
      [inputId]="'email'"
      [label]="'E-mail'"
      [control]="identificationForm.get('email')!"
      [placeholder]="'Enter your email'"
      [errorMessage]="'VALIDATION.emailRequired' | translate"
    ></app-shared-input>

    <!-- User Type Selection -->
    <app-option-button-group
      [control]="identificationForm.get('userType')!"
      [label]="'iAmAn' | translate"
      [errorMessage]="'VALIDATION.userTypeRequired' | translate"
    ></app-option-button-group>

    <!-- Login if you have an account link -->
    <button
      (click)="redirectToLogin()"
      class="font-semibold text-sm text-left block w-full text-[#848484]"
      [innerHTML]="'orLoginIfYouHaveAnAccount' | translate"
    ></button>
  </form>
</div>
